import React, {useEffect, useState} from 'react'
import {useQuery} from 'react-query'
import {BASE_URL} from '../config'
import axios from 'axios'
import usePaginationCounts from '../../utils/hooks/usePaginationCounts'
import {IDLRList} from './_model'
import {searchItems} from '../../utils/helperFunction/_helper'
import {ListViewProvider} from '../../utils/contextProvider/ListViewProvider'
import TableContentHeader from '../../utils/components/table-content/TableContentHeader'
import {KTCard} from '../../../_metronic/helpers'
import TableContent from '../../utils/components/table-content/TableContent'
import TablePagination from '../../utils/components/table-content/TablePagination'
import dlrListTableColumn from './dlrListTableColumn'
import toast from 'react-hot-toast'

const GET_DLR_LIST = `${BASE_URL}/api/protect/getDlrPushListWithPagenation`
const GET_DLR_BY_ID = `${BASE_URL}/api/protect/getDlrPushConfById?dlrId=`

type Props = {
  searchTerm: string
  onSelectDlr: (dlr: IDLRList) => void
}

const DLRListTable = ({searchTerm, onSelectDlr}: Props) => {
  const {
    pagination: {page, size, totalElement},
    updatePagination,
    handlePageChange,
    handlePagePerItem,
  } = usePaginationCounts(1, 10)

  const [filteredDlrList, setFilteredDlrList] = useState<IDLRList[]>([])

  const {
    data: dlr,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['dlrManagementList', {page, size}],
    queryFn: async () => {
      const response = await axios.get(GET_DLR_LIST, {
        params: {page, size},
      })

      const result = await response.data

      return {
        list: result.data,
        pagination: result.pagenationResponse,
      }
    },
    // staleTime: Infinity
  })

  const handleSelectDlr = async (selectType: string, id: number) => {
    console.log(selectType, id)
    toast.loading('Processing..')
    const {data} = await axios.get(`${GET_DLR_BY_ID}${id}`)
    console.log(data)
    if (data) {
      toast.dismiss()
      onSelectDlr(data)
    }
  }

  useEffect(() => {
    if (dlr) {
      const keys: (keyof IDLRList)[] = ['userName', 'faildUrl', 'successUrl']
      const filteredData = searchItems(dlr.list, searchTerm, keys)

      setFilteredDlrList(filteredData || [])
      updatePagination(dlr.pagination)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm, dlr])

  return (
    <ListViewProvider isLoading={isLoading} data={filteredDlrList}>
      <TableContentHeader size={size} handlePagePerItem={handlePagePerItem} />
      <>
        <TableContent
          isLoading={isLoading}
          tableData={filteredDlrList}
          tableColumn={dlrListTableColumn(handleSelectDlr)}
          error={error as Error}
        >
          {isLoading && !dlr ? (
            <div className='d-flex justify-content-center'>
              <div className='spinner-border' role='status'>
                <span className='visually-hidden'>Loading...</span>
              </div>
            </div>
          ) : (
            <TablePagination
              totalElement={totalElement}
              isLoading={isLoading}
              itemsPerPage={size}
              currentPage={page}
              handlePageChange={handlePageChange}
            />
          )}
        </TableContent>
      </>
    </ListViewProvider>
  )
}

export default DLRListTable
